export default "__VITE_ASSET__f5S1Beyy__"